import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ASSETS_URL} from '../../../utils/resources';
import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {FileModel} from './File.model';

@injectable()
export class FileFactory
  implements BaseDomainFactory<FileModel, FileModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(config: FileModel.Props) {
    return this.modelsRegistry.put(new FileModel(config));
  }

  createYcLogoFile(size: 60 | 120 | 180 | 340, isTransparent?: boolean) {
    const src: FileModel.Src = {
      mime: 'image/png',
      size,
      url: `${ASSETS_URL}/${size}x${size}${isTransparent ? 't' : ''}.png`,
    };

    return this.create({
      _sources: {
        [FileModel.THUMBS.IMAGE]: src,
        [FileModel.THUMBS.ORIGINAL]: src,
        [FileModel.THUMBS.PLAYABLE]: null,
        [FileModel.THUMBS.PREVIEW]: {
          ...src,
          imageSize: {
            height: size,
            width: size,
          },
        },
        [FileModel.THUMBS.THUMB_250]: src,
        [FileModel.THUMBS.THUMB_500]: src,
        [FileModel.THUMBS.THUMB_1000]: src,
        [FileModel.THUMBS.TRANSCRIPT]: null,
      },
      description: 'Logo from S3 assets',
      fileName: 'YCLogo',
      fileType: FileModel.Type.IMAGE,
      id: `yc-logo-${size}-${Date.now()}`,
      isUploaded: true,
      usedByIds: [],
      userId: '',
    });
  }
}
